import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LENSES, LensKey } from './lens';

// Switches the analysis screen between its points of view (actions, people and roles, ...), each over the same models
@Component({
    selector: 'app-lens-switcher',
    standalone: true,
    imports: [MatIconModule, MatTooltipModule],
    template: `
        <nav class="lenses" aria-label="Analysis view" data-testid="lens-switcher">
            @for (lens of lenses; track lens.key) {
            <button type="button" class="lens" [class.active]="lens.key === current" [attr.aria-current]="lens.key === current ? 'page' : null"
                [matTooltip]="lens.description" (click)="go(lens.key)" [attr.data-testid]="'lens-' + lens.key">
                <mat-icon>{{ lens.icon }}</mat-icon><span>{{ lens.label }}</span>
            </button>
            }
        </nav>
    `,
    styles: [`
        .lenses { display: flex; gap: 4px; padding: 4px; border-radius: 10px; background: var(--line, #e5e7eb); }
        .lens { flex: 1 1 0; display: flex; align-items: center; justify-content: center; gap: 4px; min-width: 0; padding: 6px 2px; border: 0;
            border-radius: 7px; background: transparent; font: inherit; font-size: 12.5px; color: var(--slate, #475569); cursor: pointer; }
        .lens span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        .lens mat-icon { font-size: 18px; width: 18px; height: 18px; flex: none; }
        .lens:hover { color: #1f2937; }
        .lens.active { background: #fff; color: #1f2937; font-weight: 600; box-shadow: 0 1px 2px rgba(0, 0, 0, .12); }
        .lens:focus-visible { outline: 2px solid #3987e5; outline-offset: 1px; }
    `],
})
export class LensSwitcherComponent {
    @Input() current: LensKey = 'actions';
    @Input() organisationKey = '';
    readonly lenses = LENSES;

    constructor(private router: Router) {}

    go(key: LensKey) {
        const lens = this.lenses.find(l => l.key === key);
        if (!lens || key === this.current || !this.organisationKey) return;
        void this.router.navigateByUrl(lens.url(this.organisationKey));
    }
}
